// 业务管理
import supplyDemand from './supply-demand'
import common from './common'
import review from './review'
import feedback from './feedback'
import consultservice from './consultservice'

export default {
  supplyDemand,
  common,
  review,
  feedback,
  consultservice
}



// WEBPACK FOOTER //
// ./src/api/business/index.js